module.exports = __webpack_public_path__ + "static/media/HCMM225.aca55ecb.jpg";